module.exports = __webpack_public_path__ + "img/ch23.7275cb5b.png";